import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "..";

export interface TimerState {
  searchId: string;
  isExpired: boolean;
  isRunning: boolean;
  isCancelled: boolean;
  maxTime: number;
  startedAt: number;
  restartFlag: string;
}

const initialState: TimerState = {
  searchId: "",
  isExpired: false,
  isRunning: false,
  isCancelled: false,
  maxTime: 10 * 60 * 1000,
  startedAt: 0,
  restartFlag: "",
};

let timer: ReturnType<typeof setTimeout> | null = null;

const timerSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    setSearchId: (state, action: PayloadAction<string>) => {
      state.searchId = action.payload;
      state.isExpired = false;
    },
    startTimerState: (state) => {
      state.isRunning = true;
      state.isExpired = false;
      state.startedAt = Date.now();
    },
    expireTicket: (state) => {
      state.isExpired = true;
      state.isRunning = false;
    },
    resetTimerState: (state) => {
      state.isRunning = false;
      state.isExpired = false;
      state.isCancelled = true;
    },
    setMaxTime: (state, action: PayloadAction<number>) => {
      state.maxTime = action.payload;
    },
    setRestartFlag: (state, action: PayloadAction<string>) => {
      state.restartFlag = action.payload;
    },
  },
});

export const { setSearchId, startTimerState, expireTicket, resetTimerState, setMaxTime, setRestartFlag } = timerSlice.actions;

export const startTimer = () => (dispatch: AppDispatch, getState: any) => {
  if (timer) clearTimeout(timer);
  const { maxTime } = getState().timer as TimerState;
  dispatch(startTimerState());
  timer = setTimeout(() => {
    dispatch(expireTicket());
    timer = null;
  }, maxTime);
};

export const cancelTimer = () => (dispatch: AppDispatch) => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  dispatch(resetTimerState());
};

export const setMaxTimeThunk = (value: number) => (dispatch: AppDispatch) => {
  dispatch(setMaxTime(value));
};

export default timerSlice.reducer;
